<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :columns="columnList"
        :customVisible="true"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'enable'">
              {{ scope.row[item.field] === 1 ? '是' : '否' }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
          <template v-slot:content="{ row }">
            <div>
              <vxe-table
                border
                show-overflow
                resizable
                ref="secondClaim"
                class="vxe-table-element"
                size="mini"
                align="left"
                min-width="120"
                :auto-resize="true"
                :data="row.operateTypeList ? row.operateTypeList : []"
                max-height="200px"
              >
                <vxe-table-column
                  type="seq"
                  width="50"
                  :title="$t('receivablesManage.receivablesClaimInfo.seq')"
                ></vxe-table-column>
                <vxe-table-column field="operateType" title="操作类型编码"></vxe-table-column>
                <vxe-table-column field="operateTypeName" title="操作类型名称"></vxe-table-column>
                <vxe-table-column field="enable" title="是否启用">
                  <template v-slot:default="{ row }">
                    {{ row.enable === 1 ? '是' : '否' }}
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiTable from '@/components/SiruiTable';
  // import query from '../../../common/lang/financeCenter/GeneralAccounting/voucher/query';
  export default {
    name: 'list',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        query: {
          billType: null,
          billTypeName: null,
          enable: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        load: false,
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            // 切换
            type: 'expand',
            width: '50',
            fixed: 'left',
          },
          { field: 'billType', title: '单据类型编码', sortable: true },
          { field: 'billTypeName', title: '单据类型名称', sortable: true },
          { field: 'route', title: '路由', sortable: true },
          { field: 'enable', title: '是否启用', sortable: true },
        ],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            type: 'input',
            name: '单据类型',
            prop: 'billType',
            placeholder: '请输入单据类型',
          },
          {
            type: 'input',
            name: '单据类型名称',
            prop: 'billTypeName',
            placeholder: '请输入单据类型名称',
          },
          {
            type: 'select',
            name: '是否启用',
            prop: 'enable',
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
          },
        ];
      },
    },
    mounted() {
      this.getData();
      this.getColumnInfo();
      this.getButtonList();
    },
    methods: {
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post('/component/approvalBillType/queryPage', query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      chooseClick(type) {
        if (type === 'add') {
          this.$router.push('/todoCenter/billConfigAdd');
        } else if (type === 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据进行修改',
              type: 'error',
            });
            return;
          }
          this.$router.push({
            path: '/todoCenter/billConfigEdit',
            query: { id: this.multipleSelection[0].id },
          });
        } else if (type === 'del') {
          this.del();
        }
      },
      //删除
      del() {
        this.$confirmAction()
          .then(() => {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            console.log(this.multipleSelection);
            this.$axios.post('/component/approvalBillType/delete', ids).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
                this.multipleSelection = [];
                this.$refs.siruiTable.clearCheckboxReserve();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
    },
  };
</script>

<style scoped></style>
